import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { UitkInput } from './uitk-input.esm.js';

var UitkEmailInput = /** @class */ (function (_super) {
    __extends(UitkEmailInput, _super);
    function UitkEmailInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkEmailInput.prototype.render = function () {
        return React.createElement(UitkInput, __assign({}, this.props, { type: "email" }));
    };
    UitkEmailInput.displayName = 'UitkEmailInput';
    return UitkEmailInput;
}(React.Component));

export { UitkEmailInput };
